<template>
  <div>
    <div>
      <b-card title="UnMatched Bank Statement">
        <b-row class="mb-1">
          <!-- search input -->
          <b-col>
            <section>
              <b-button
                v-b-modal.modal-filter-orders
                variant="outline-primary"
                class="d-flex"
              >
                <feather-icon icon="FilterIcon" />Filter
              </b-button>
            </section>
          </b-col>
          <b-col>
            <b-form-group
              v-if="dataFiltered == true"
              class="d-flex justify-content-center"
            >
              <!-- search input -->
              <div>
                <b-form-input
                  v-model="searchTerm"
                  type="search"
                  placeholder="search"
                />
              </div>
            </b-form-group>
          </b-col>

          <b-col
            v-if="dataFiltered === true"
            class="d-flex justify-content-end"
          >
            <xlsx-workbook>
              <xlsx-sheet
                v-for="sheet in sheets"
                :key="sheet.name"
                :collection="sheet.data"
                :sheet-name="sheet.name"
              />
              <xlsx-download>
                <b-button variant="primary" class="d-flex">
                  <feather-icon icon="DownloadCloudIcon" /> Export
                </b-button>
              </xlsx-download>
            </xlsx-workbook>
          </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table
          :columns="paymentMatchForm ===1 || refundMatchForm ===1 ? columns1 : columns2"
          :rows="reconciliations"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props"> 
          <!-- Column: Action -->
          <span v-if="props.column.field === 'action' && ((settransactionType === 1) || (settransactionType === 2 && setMatchForm === 2) )">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                v-if="setMatchForm === 2"
                variant="success"
                @click="approveorcomplete(props.row)"
                >
                  <feather-icon icon="CheckIcon" class="mr-50" />

                  <span v-if="settransactionType === 1">Approve</span>
                  <span v-if="settransactionType === 2">Complete</span>
                </b-dropdown-item>
                <b-dropdown-item
                v-if="settransactionType === 1 && setMatchForm === 1"
                variant="success"
                @click="resolveGetByRef(props.row)"
                >
                  <feather-icon icon="CheckIcon" class="mr-50" />

                  <span >Resolve GetByRef</span>
                </b-dropdown-item>
                <b-dropdown-item
                v-if="settransactionType === 1 && setMatchForm === 1"
                variant="success"
                @click="resolveManually(props.row)"
                >
                  <feather-icon icon="CheckIcon" class="mr-50" />

                  <span >Resolve Manually</span>
                </b-dropdown-item>
                
              </b-dropdown>
            </span>
          </span>

        </template>
          <template slot="pagination-bottom" slot-scope="props">
            <!-- pagination -->

            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['5', '10', '15', '30', '50']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

        <b-row>
          <b-col>
            <b-modal
              id="modal-filter-orders"
              title="Filter Reconcilation"
              ok-title="Search"
              cancel-variant="outline-secondary"
              size="lg"
              @ok="filterBankStatments"
            >
              <b-form>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Provider option"
                      label-for="provider-option"
                    >
                      <b-form-select
                        id="merchantId"
                        v-model="filterFopId"
                        :options="providers"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Category Type"
                      label-for="category-type"
                    >
                      <b-form-select
                        id="merchantId"
                        v-model="accountGroup"
                        :options="accountGroupEnum"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Paid Date Range"
                      label-for="paid-date-range"
                    >
                      <flat-pickr
                        v-model="trxnDateRange"
                        class="form-control"
                        :config="{ mode: 'range', maxDate: 'today' }"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Transaction Type"" label-for="transaction-type">
                      <b-form-select
                        id="transaction-type"
                        v-model="settransactionType"
                        :options="transactionType"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Match Form" label-for="match-form">
                      <b-form-select
                        id="refund-exception-type"
                        v-model="setMatchForm"
                        :options="matchFormfunction"
                        :key="settransactionType"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>
          </b-col>
        </b-row>
  <b-modal
        id="modal-approve-order"
        ref="modal"
        header-bg-variant="warning"
        @ok="handleApproveOrComplete"
      >
        <form ref="form" @submit.stop.prevent="handleApproveOrComplete">
          <b-form-group
            label=" Please Provide Remark"
            label-for="name-input"
            invalid-feedback="Remark is required"
            :state="referenceState"
          >
            <b-form-input
              id="name-input"
              v-model="remark"
              :state="referenceState"
              required
            />
          </b-form-group>
        </form>
      </b-modal>

      <b-modal
        id="modal-resolveManually"
        ref="modal"
        header-bg-variant="warning"
        @ok="handleResolveManually"
      >
        <form ref="form" @submit.stop.prevent="handleResolveManually">
          <b-form-group
            label="New Transaction Reference"
            label-for="newReference-input"
          >
            <b-form-input
              id="newReference-input"
              v-model="selectedRow.newReference"
            />
          </b-form-group>
          <b-form-group
            label="New Transaction Date"
            label-for="newTransactionDate-input"
          >
             <flat-pickr
              v-model="selectedRow.newTransactionDate"
              class="form-control"/>
          </b-form-group>
          <b-form-group
            label=" Please Provide Remark"
            label-for="name-input"
            invalid-feedback="Remark is required"
            :state="referenceState"
          >
            <b-form-input
              id="name-input"
              v-model="selectedRow.remark"
              :state="referenceState"
              required
            />
          </b-form-group>
        </form>
      </b-modal>

        <!-- loadings -->
        <b-overlay :show="isLoading" no-wrap rounded="sm" />
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormDatepicker,
  BRow,
  BCol,
  BForm,
  BTable,
  BCardText,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";
import flatPickr from "vue-flatpickr-component";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import XlsxSheet from "../../../../node_modules/vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "../../../../node_modules/vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "../../../../node_modules/vue-xlsx/dist/components/XlsxWorkbook";

export default {
  components: {
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    VueGoodTable,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormDatepicker,
    flatPickr,
    BForm,
    BTable,
    BCardText,
    BCardActions,
    BFormCheckbox,
    BDropdown,
    BDropdownItem,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      pageLength: 5,
      dir: false,
      rangeDate: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${nowDate.getUTCMonth() +
        1}-${nowDate.getUTCDate()}`,
      orderDateRange: "",
      trxnDateRange: "",
      transactionType: "",
      VendorTxnRefNumber: "",
      orderStartDate: "",
      trxnStartDate: "",
      orderEndDate: "",
      trxnEndDate: "",
      orderFirstName: "",
      orderLastName: "",
      orderEmail: "",
      orderPhone: "",
      orderAmount: "",
      orderCurrency: "",
      orderCity: "",
      orderCountry: "",
      orderChannel: "",
      selectedOrder: "",
      filterOrderId: "",
      filterFopId: 0,
      accountGroup: 1,
      filterFirstName: "",
      filterLastName: "",
      filtertrnxDate: "",
      bankName: "",
      transactionDate: "",
      valueDate: "",
      postingDate: "",
      transactionType: "",
      transactionReference: "",
      debit: "",
      credit: "",
      orderCode: "",
      payerAccount: "",
      payerName: "",
      columns1: [
        {
          label: "Merchant Name",
          field: "merchantName",
        },
        {
          label: "Provider",
          field: "paymentOptionName",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency",
        },

        {
          label: "Transaction Reference",
          field: "transactionReference",
        },
        {
          label: "Transaction Date",
          field: "transactionDateString",
        },
        {
          label: "Transaction Type",
          field: "transactionType",
        },
        {
          label: "Customer Name",
          field: "customerName",
        },
        {
          label: "Account Number",
          field: "accountNumber",
        },
        {
          label: "Remark",
          field: "remark",
        },
         {
          label: "Action",
          field: "action",
        },
      ],
      columns2: [
        {
          label: "Merchant Name",
          field: "merchantName",
        },
        {
          label: "Provider",
          field: "provider",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency",
        },

        {
          label: "Transaction Reference",
          field: "transactionReference",
        },
        {
          label: "Transaction Date",
          field: "transactionDateString",
        },
        {
          label: "Transaction Type",
          field: "transactionType",
        },
        {
          label: "Customer Name",
          field: "customerName",
        },
        {
          label: "Account Number",
          field: "accountNumber",
        },
        {
          label: "Remark",
          field: "remark",
        },
         {
          label: "Action",
          field: "action",
        },
      ],
      accountGroupEnum: [
        { value: 1, text: "Revenue Ticket" },
        { value: 2, text: "E-Staff Ticket" },
        { value: 3, text: "Aviation University" },
        { value: 4, text: "Ethiopian Visa" },
        { value: 5, text: "Ethiopian Passport" },
        { value: 6, text: "Ethiopian OriginID" },
        { value: 7, text: "Ethiopian Cargo" },
      ],
      paymentMatchForm: [
        {
          value: 1,
          text: "Order - STMT",
        },
        {
          value: 2,
          text: "STMT - Order",
        },
      ],
      refundMatchForm: [
        {
          value: 1,
          text: "Refund - STMT",
        },
        {
          value: 2,
          text: "STMT - Refund",
        },
      ],
      setMatchForm: 1,
      transactionType: [
        {
          value: 1,
          text: "Payment",
        },
        {
          value: 2,
          text: "Refund",
        },
      ],
      settransactionType: 1,
      remark:"",
      url: "",
      providers: [{ value: 0, text: "--select Provider--" }],
      selectedCurrency: "ETB",
      searchTerm: "",
      editabelData: {},
      orderHistory: [],
      orderRefundHistory: [],
      orderHistories: [
        "paymentStatusDescription",
        "transactionDate",
        "actionTakenBy",
      ],
      referenceNumber: "",
      referenceState: null,
      selectedRow: [],
      titleApprove: "",
      amount: 0,
      refundRequest: {
        orderCode: "",
        amount: 0,
        currency: "ETB",
        accountNumber: "",
        isRefundToSeparateAccountNumber: false,
      },
      status: "monthly",
      monthlyPlanShow: true,
      pricing: {
        basicPlan: {
          title: "Basic",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot1.svg"),
          subtitle: "A simple start for everyone",
          monthlyPrice: 0,
          yearlyPlan: {
            perMonth: 0,
            totalAnual: 0,
          },
          planBenefits: [
            "100 responses a month",
            "Unlimited forms and surveys",
            "Unlimited fields",
            "Basic form creation tools",
            "Up to 2 subdomains",
          ],
          popular: false,
        },
        standardPlan: {
          title: "Standard",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot2.svg"),
          subtitle: "For small to medium businesses",
          monthlyPrice: 49,
          yearlyPlan: {
            perMonth: 40,
            totalAnual: 480,
          },
          planBenefits: [
            "Unlimited responses",
            "Unlimited forms and surveys",
            "Instagram profile page",
            "Google Docs integration",
            "Custom “Thank you” page",
          ],
          popular: true,
        },
        enterprisePlan: {
          title: "Enterprise",
          // eslint-disable-next-line global-require
          img: require("@/assets/images/illustration/Pot3.svg"),
          subtitle: "Solution for big organizations",
          monthlyPrice: 99,
          yearlyPlan: {
            perMonth: 80,
            totalAnual: 960,
          },
          planBenefits: [
            "PayPal payments",
            "Logic Jumps",
            "File upload with 5GB storage",
            "Custom domain support",
            "Stripe integration",
          ],
          popular: false,
        },
      },
      reconciliations: [],
      ordersId: [],
      sheets: [{ name: "Bank Statments", data: [] }],
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },

      matchFormfunction() {
      if (this.settransactionType === 1) {
        return this.paymentMatchForm;
      } else if (this.settransactionType === 2) {
        return this.refundMatchForm;
      }
    },
  },
  created() {
    this.fetchallProvider();
  },
  beforeCreate() {
    this.$http.get("/account-setting/data").then((res) => {
      this.options = res.data;
    });
  },
  methods: {
    fetchallProvider() {
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Reconciliation-ViewUnMatched"
      );
      axios
        .get("/Provider/api/V1.0/Provider/GetAll")
        .then((res) => {
          res.providers.map((provider) => {
            this.providers.push({
              value: provider.id,
              text: provider.providerName,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterBankStatments() {
      if (this.orderDateRange !== "") {
        const [orderSttDate, orderEdDate] = this.orderDateRange.split(" to ");

        if (this.orderDateRange.includes("to")) {
          this.orderStartDate = orderSttDate;
          this.orderEndDate = orderEdDate;
        } else {
          this.orderStartDate = this.orderDateRange;
          this.orderEndDate = this.orderDateRange;
        }
      }

      if (this.trxnDateRange !== "") {
        const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
        // this.trxnEndDate = `${trxnEdDate.trim()}`
        // this.trxnStartDate = `${trxnSttDate.trim()}`

        if (this.trxnDateRange.includes("to")) {
          this.trxnStartDate = trxnSttDate;
          this.trxnEndDate = trxnEdDate;
        } else {
          this.trxnStartDate = this.trxnDateRange;
          this.trxnEndDate = this.trxnDateRange;
        }
      }

      this.setMatchForm === 1
        ? (this.url = `/Reconciliation/api/V1.0/Reconciliation/GetMissingInStatement?accountGroup=${this.accountGroup}&transactionType=${this.settransactionType}&transactionDateFrom=${this.trxnStartDate}&transactionDateTo=${this.trxnEndDate}&providerId=${this.filterFopId}`)
        : (this.url = `/Reconciliation/api/V1.0/Reconciliation/GetMissingInOrder?accountGroup=${this.accountGroup}&transactionType=${this.settransactionType}&transactionDateFrom=${this.trxnStartDate}&transactionDateTo=${this.trxnEndDate}&providerId=${this.filterFopId}`);
      
      // Api call
      this.isLoading = true;
      axios
        .get(this.url)
        .then((res) => {
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.reconciliations = res.discrepancyStatements;
          res.discrepancyStatements.map((m) => {
            this.sheets[0].data.push({
              "Merchant Name": m.merchantName,
              Provider: m.Provider,
              "Credit Account Number": m.creditAccountNumber,
              "custom Order Code": m.customOrderCode,
              Amount: m.amount,
              Currency: m.currency,
              "Transaction Reference": m.transactionReference,
              "Transaction Date": m.transactionDateString,
              "Transaction Type": m.transactionType,
              "Customer Name": m.customerName,
              "Account Number": m.accountNumber,
              remark: m.remark,
            });
          });
          this.isLoading = false;
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        })
        .catch((res) => {
          this.isLoading = false;
          this.reconciliations = [];

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${res.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
          this.orderStartDate = "";
          this.orderEndDate = "";
          this.trxnEndDate = "";
          this.trxnStartDate = "";
        });
    },
     approveorcomplete(row) {
      this.selectedRow = row;
      this.$bvModal.show("modal-approve-order");
    },
     checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.referenceState = valid;
      return valid;
    },
     handleApproveOrComplete(bvModalEvt) {
      bvModalEvt.preventDefault();
       if (!this.checkFormValidity()) {
        return;
      }
      this.$nextTick(() => {
        this.$bvModal.hide("modal-approve-order");
        this.isLoading = true;
        axios
          .post("/Reconciliation/api/V1.0/Reconciliation/ApproveUnmatechedOrders", {
            customOrderCode: this.selectedRow.customOrderCode,
            amount: this.selectedRow.amount,
            currency: this.selectedRow.currency,
            transactionReference: this.selectedRow.transactionReference,
            paymentOptionId: this.selectedRow.paymentOptionId,
            transactionType: this.settransactionType,
            Remark: this.remark,
          })
          .then((res) => {
            this.$swal({
              icon: "success",
              title: "Order Approved!",
              text: res.message,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.isLoading = false;
          })
          .catch((res) => {
            this.isLoading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: `${res.data.message}`,
              },
            });
          });
      });
    },
    resolveGetByRef(row) {
      this.isLoading = true;
      this.selectedRow = row;
        axios
          .post("/Reconciliation/api/V1.0/Reconciliation/CheckMismatchedStatementsfromBanks", {
            merchantName: this.selectedRow.merchantName,
            ProviderName: this.selectedRow.provider,
            customOrderCode: this.selectedRow.customOrderCode,
            amount: this.selectedRow.amount,
            currency: this.selectedRow.currency,
            transactionReference: this.selectedRow.transactionReference,
            transactionDate: this.selectedRow.transactionDate,
            transactionType: this.selectedRow.transactionType,
            customerName: this.selectedRow.customerName,
            accountNumber: this.selectedRow.accountNumber,
            newReference: null,
            newTransactionDate: null,
            remark: this.selectedRow.remark,
          })
          .then((res) => {
            this.$swal({
              icon: "success",
              title: res.message,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.filterBankStatments();
            this.isLoading = false;
          })
          .catch((res) => {
            this.isLoading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: `${res.data.message}`,
              },
            });
          });
    },
     resolveManually(row) {
      this.selectedRow = row;
      this.selectedRow.remark ="";
      this.$bvModal.show("modal-resolveManually");
    },
     handleResolveManually(bvModalEvt) {
      bvModalEvt.preventDefault();
       if (!this.checkFormValidity()) {
        return;
      }
      console.log(this.selectedRow.newTransactionDate)
      this.$nextTick(() => {
        this.$bvModal.hide("modal-resolveManually");
        this.isLoading = true;
        axios
          .post("/Reconciliation/api/V1.0/Reconciliation/SaveResolvedMismatchedStatements", {
            merchantName: this.selectedRow.merchantName,
            ProviderName: this.selectedRow.provider,
            customOrderCode: this.selectedRow.customOrderCode,
            amount: this.selectedRow.amount,
            currency: this.selectedRow.currency,
            transactionReference: this.selectedRow.transactionReference,
            transactionDate: this.selectedRow.transactionDate,
            transactionType: this.selectedRow.transactionType,
            customerName: this.selectedRow.customerName,
            accountNumber: this.selectedRow.accountNumber,
            newReference: this.selectedRow.newReference ? this.selectedRow.newReference : null,
            newTransactionDate: this.selectedRow.newTransactionDate,
            remark: this.selectedRow.remark,
          })
          .then((res) => {
            this.$swal({
              icon: "success",
              title: res.message,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.filterBankStatments();
            this.isLoading = false;
          })
          .catch((res) => {
            this.isLoading = false;
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: `${res.data.message}`,
              },
            });
          });
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
